const FETCH_MY_EPISODE = 'studio/episodeCreateEdit/FETCH_EPISODE';

const FETCH_MY_EPISODE_BEHIND = 'studio/episodeCreateEdit/FETCH_EPISODE_BEHIND';

const UPDATE_EPISODE_NAME = 'studio/episodeCreateEdit/UPDATE_EPISODE_NAME';

const PATCH_MY_EPISODE = 'studio/episodeCreateEdit/PATCH_EPISODE';

const SAVE_DRAFT = 'studio/episodeCreateEdit/SAVE_DRAFT';

const FETCH_FIREBASE_TOKEN = 'studio/episodeCreateEdit/FETCH_FIREBASE_TOKEN';

const POST_EPISODE_BOOKING = 'studio/episodeCreateEdit/POST_EPISODE_BOOKING';

export default {
  FETCH_MY_EPISODE,
  FETCH_MY_EPISODE_BEHIND,
  UPDATE_EPISODE_NAME,
  PATCH_MY_EPISODE,
  SAVE_DRAFT,
  FETCH_FIREBASE_TOKEN,
  POST_EPISODE_BOOKING,
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/episodeCreateEdit/types.js